"use client";

import { c as _c } from "react/compiler-runtime";
import { parseAsBoolean, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
export function useHasNftQueryParam() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsBoolean.withDefault(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [hasNft, setHasNft] = useQueryState(QUERY_PARAM_KEYS.hasNft, t0);
  let t1;
  if ($[1] !== setHasNft) {
    t1 = async function toggleHasNft() {
      await setHasNft(_temp);
    };
    $[1] = setHasNft;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleHasNft = t1;
  let t2;
  if ($[3] !== hasNft || $[4] !== toggleHasNft) {
    t2 = {
      hasNft,
      toggleHasNft
    };
    $[3] = hasNft;
    $[4] = toggleHasNft;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(prev) {
  return prev ? null : true;
}